import {InquiryButtonTypeName} from "../../offer/detail/constants/inquiry_button_type";
import {hitGoogleTagManager} from "./hit_google_tag_manager";

export const gtmEventShowSimilarPropertiesCTA = (clickText: InquiryButtonTypeName | string) => {
    const gtmData = {
        event: "zobacz_podobne_oferty_banner",
        event_action: "view",
        event_label: clickText
    };
    hitGoogleTagManager(gtmData);
};

export const gtmEventClickSimilarPropertiesCTA = (clickText: InquiryButtonTypeName | string) => {
    const gtmData = {
        event: "zobacz_podobne_oferty_banner",
        event_action: "click",
        event_label: clickText
    };
    hitGoogleTagManager(gtmData);
};
import {InquiryButtonTypeName} from "../../offer/detail/constants/inquiry_button_type";
import {hitGoogleTagManager} from "./hit_google_tag_manager";

export const gtmEventShowSimilarPropertiesCTA = (clickText: InquiryButtonTypeName | string) => {
    const gtmData = {
        event: "zobacz_podobne_oferty_banner",
        event_action: "view",
        event_label: clickText
    };
    hitGoogleTagManager(gtmData);
};

export const gtmEventClickSimilarPropertiesCTA = (clickText: InquiryButtonTypeName | string) => {
    const gtmData = {
        event: "zobacz_podobne_oferty_banner",
        event_action: "click",
        event_label: clickText
    };
    hitGoogleTagManager(gtmData);
};
